export default __webpack_public_path__ + "static/media/element_83.7630be3c.webp";